module.exports = __webpack_public_path__ + "static/media/data-log-sharing.06016245.svg";